module.exports = __webpack_public_path__ + "static/media/obtaininSteps@2x.3f6b2dca.png";